<template>
  <div>
    <div class="promoterManage-container div-layout">
      <module-title title="推广者管理">
        <div class="right">
          <el-button type="primary" size="medium" icon="el-icon-plus" @click="dialogRulesVidible=true">
            推广者保护机制
          </el-button>
          <el-button type="primary" size="medium" icon="el-icon-plus" @click="dialogAddVidible=true">
            添加代理商
          </el-button>
          <el-button type="primary" size="medium" icon="el-icon-download" @click="handleExportFilter">
            导出
          </el-button>
        </div>
      </module-title>
      <el-form class="searchForm" :inline="true" label-position="right" label-width="100px">
        <el-form-item label="推广者ID：" prop="spreadCode">
          <el-input v-model="searchForm.spreadCode" name="spreadCode" placeholder="请输入推广者ID" class="handle-form-input" />
        </el-form-item>
        <el-form-item label="用户身份：" prop="agentGrade">
          <el-select v-model="searchForm.agentGrade" name="agentGrade" size="medium" class="edit-form-input">
            <el-option label="全部" value="" />
            <el-option v-for="(item,index) in leaveList" :key="index" :label="item.name" :value="item.value" />
          </el-select>
        </el-form-item>
        <el-form-item label="账号类型：" prop="spreadType">
          <el-select v-model="searchForm.spreadType" name="spreadType" size="medium" class="edit-form-input">
            <el-option label="全部" value="" />
            <el-option label="个人" value="1" />
            <el-option label="学校" value="2" />
            <el-option label="代理商" value="3" />
          </el-select>
        </el-form-item>
        <el-form-item label="手机号：" prop="phoneNumber">
          <el-input v-model="searchForm.phoneNumber" oninput="value=value.replace(/[^\d]/g,'')" name="phoneNumber" maxlength="11" placeholder="请输入手机号" class="handle-form-input" @change="changeNumber" />
        </el-form-item>
        <el-form-item style="margin-left:15px;">
          <el-button type="primary" size="medium" icon="el-icon-search" @click="handleSearchFilter">
            查询
          </el-button>
        </el-form-item>
      </el-form>
      <div class="table-box">
        <el-table v-loading="listLoading" :data="spreadersInfoList" highlight-current-row fit element-loading-text="Loading" class="list-table">
          <el-table-column type="index" width="55" align="center" label="序号" />
          <el-table-column label="上级推广者ID" prop="pspreadCode" width="200" align="center" />
          <el-table-column label="推广者ID" prop="spreadCode" width="150" align="center" />
          <el-table-column label="姓名" prop="name" align="center" />
          <el-table-column label="手机号" prop="phoneNumber" width="150" align="center" />
          <el-table-column label="身份证号" prop="identityNumber" width="200" align="center" />
          <el-table-column label="账号类型" prop="spreadType" align="center">
            <template slot-scope="scope">
              {{ scope.row.spreadType==1 ? '个人':'学校' }}
            </template>
          </el-table-column>
          <el-table-column label="用户身份" width="130" prop="agentGradeName" align="center" />
          <el-table-column label="状态" width="130" prop="spreadStatus" align="center">
            <template slot-scope="scope">
              {{ scope.row.spreadStatus==0 ? '失效' : scope.row.spreadStatus==1 ?'待营销':'正常' }}
            </template>
          </el-table-column>
          <el-table-column label="最近操作时间" prop="updateDate" width="150" align="center" />
          <el-table-column label="操作" prop="name" align="center" width="400">
            <template slot-scope="scope">
              <el-button type="danger" size="small" icon="el-icon-edit" @click="deletPromoterInfo(scope.row)">
                删除
              </el-button>
              <el-button type="primary" size="small" :disabled="scope.row.spreadStatus!=1?false:true" @click="$router.push({path:'/yzdPlatform/promotionUserManage',query:{spreaderId:scope.row.id}})">
                推广用户管理
              </el-button>
              <el-button type="primary" size="small" :disabled="scope.row.spreadStatus!=1?false:true" @click="openMarketingDialog('modify',scope.row)">
                身份变更
              </el-button>
              <el-button type="primary" size="small" :disabled="scope.row.spreadStatus==1 && scope.row.spreadType!=1?false:true" @click="openMarketingDialog('market',scope.row)">
                电话营销
              </el-button>
            </template>
          </el-table-column>
        </el-table>
        <pagination
          :total="page.total"
          :page.sync="page.pageNum"
          :limit.sync="page.pageSize"
          @pagination="pageCurriculumList"
          @handleSizeChange="handleSizeChange"
        />
      </div>
    </div>
    <!-- 电话营销 -->
    <el-dialog v-if="dialogMarketingVidible" :close-on-click-modal="false" :visible.sync="dialogMarketingVidible" width="500px" title="电话营销">
      <div class="content">
        该用户为{{ currentRowData.schoolName }}旗下账号，根据系统分析其近一周使用频率较高，请与老师电话沟通，确认是否将其转化成推广者？
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button size="medium" @click="dialogMarketingVidible=false">
          取消
        </el-button>
        <el-button type="primary" size="medium" :loading="ajaxLoading" @click="submitTelemarketing">
          {{ ajaxLoading ? "Loading" : "转为推广者" }}
        </el-button>
      </div>
    </el-dialog>
    <!-- 添加推广者 -->
    <el-dialog v-if="dialogAddVidible" :close-on-click-modal="false" :visible.sync="dialogAddVidible" width="500px" title="添加推广者" @close="closePromoterDialog">
      <el-form ref="addAgentForm" label-position="right" label-width="120px" :rules="addFormRules" :model="addAgentForm">
        <el-form-item label="手机号" prop="phoneNumber">
          <el-input v-model="addAgentForm.phoneNumber" name="phoneNumber" maxlength="11" class="handle-form-input" />
        </el-form-item>
        <el-form-item label="姓名" prop="name">
          <el-input v-model="addAgentForm.name" name="name" maxlength="50" class="handle-form-input" />
        </el-form-item>
        <el-form-item label="身份证号" prop="identityNumber">
          <el-input v-model="addAgentForm.identityNumber" name="identityNumber" class="handle-form-input" />
        </el-form-item>
        <el-form-item label="等级" prop="agentGrade">
          <el-select v-model="addAgentForm.agentGrade" name="agentGrade" size="medium" class="handle-form-input">
            <el-option v-for="(item,index) in leaveList" v-show="item.value==0?false:true" :key="index" :label="item.name" :value="item.value" />
          </el-select>
        </el-form-item>
        <el-form-item label="推广者ID" prop="spreadCode">
          <el-input v-model="addAgentForm.spreadCode" name="spreadCode" maxlength="50" class="handle-form-input" />
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="medium" @click="closePromoterDialog">
          取消
        </el-button>
        <el-button type="primary" size="medium" :loading="ajaxLoading" @click="handleaddSpreaders">
          {{ ajaxLoading ? "Loading" : "确认" }}
        </el-button>
      </div>
    </el-dialog>
    <!-- 保护机制 -->
    <el-dialog v-if="dialogRulesVidible" :close-on-click-modal="false" :visible.sync="dialogRulesVidible" width="500px" title="推广者保护机制" @close="closeProtectionDialog">
      <el-form ref="protectionMechanismForm" label-position="right" label-width="150px" :model="protectionMechanismForm">
        <el-form-item label="中断续费间隔时间" prop="interruptFeeIntervalTime">
          <el-input v-model="protectionMechanismForm.interruptFeeIntervalTime" name="interruptFeeIntervalTime" maxlength="2" class="editRules-form-input" /> 月
          <div class="right-box">
            <el-tooltip class="downNum" effect="dark" placement="bottom">
              <div slot="content">
                中断续费：当推广者下面的用户账号到期后(在微信公众号上推送通知消息)，<br>需要在x个月内进行续费，成功续费后依旧保存执行其分润逻辑，超出后该<br>推广者下面的该用户不再属于旗下；
              </div>
              <i class="el-icon-question" />
            </el-tooltip>
          </div>
        </el-form-item>
        <el-form-item label="与推广者断开关系暂停分润间隔时间名" prop="suspensionCommissionIntervalTime">
          <el-input v-model="protectionMechanismForm.suspensionCommissionIntervalTime" name="suspensionCommissionIntervalTime" maxlength="2" class="editRules-form-input" /> 月
          <div class="right-box">
            <el-tooltip class="downNum" effect="dark" placement="bottom">
              <div slot="content">
                与推广者断开关系暂停分润间隔时间:在用户已与推广者绑定后,在中断续费断绑<br>或通过线下渠道进行脱离绑定后,y个月内该账号不会被其他账号进行分润(即使<br>绑定也不分润);y个月后,被推广者说服购买后，按产品剩余时间比列部分分润;
              </div>
              <i class="el-icon-question" />
            </el-tooltip>
          </div>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="medium" @click="closeProtectionDialog">
          取消
        </el-button>
        <el-button type="primary" size="medium" :loading="ajaxLoading" @click="submitProtectionMechanism">
          {{ ajaxLoading ? "Loading" : "确认" }}
        </el-button>
      </div>
    </el-dialog>
    <!-- 更新推广者身份 -->
    <el-dialog v-if="dialogAdjustmentVidible" :close-on-click-modal="false" :visible.sync="dialogAdjustmentVidible" width="400px" title="身份变更" @close="closeAgentFradeDialog">
      <el-form label-position="right" label-width="120px">
        <el-form-item label="推广者身份调整" prop="agentGrade">
          <el-select v-model="updateForm.agentGrade" name="agentGrade" size="medium" class="handle-form-input">
            <el-option v-for="(item,index) in leaveList" :key="index" :label="item.name" :value="item.value" />
          </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="medium" @click="closeAgentFradeDialog">
          取消
        </el-button>
        <el-button type="primary" size="medium" :loading="ajaxLoading" @click="updateIdentity">
          {{ ajaxLoading ? "Loading" : "确认" }}
        </el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import { agentLevelMixin } from '../minxins/agentLevel';
import { createSpreadersInfo, getSpreadersList, translationSpreaders, translationRemove, saveProtectionsInfo, getProtectionsInfo, changeIdentity, exportSpreadersExcel } from '@/api/yzdPlatformManage/promoterManage';
export default {
  mixins: [agentLevelMixin],
  data() {
    return {
      searchForm: {
        spreadCode: '', // 推广者ID
        agentGrade: '', // 用户身份
        spreadType: '', // 账号类型
        phoneNumber: ''// 手机号
      },
      page: { // 分页参数
        total: 0,
        pageNum: 1,
        pageSize: 10
      },
      listLoading: false, // 表格刷新loading
      dialogMarketingVidible: false, // 电话营销
      dialogAddVidible: false, // 添加推广者
      ajaxLoading: false,
      addAgentForm: {
        agentGrade: '', // 代理商等级
        identityNumber: '', // 身份证号
        name: '', // 姓名
        phoneNumber: '', // 电话号码
        spreadCode: ''
      },
      addFormRules: {
        spreadCode: [{
          validator: function(rule, value, callback) {
            // let abc=/^[\d\s*]+$|^[A-Za-z\s*]+$/;
            if (value && /^[\da-z]+$/i.test(value) === false) {
              callback(new Error('只能输入数字和字母'));
            } else {
              // 校验通过
              callback();
            }
          },
          trigger: 'blur'
        }]
      },
      dialogRulesVidible: false,
      spreadersInfoList: [], // 推广者列表
      currentRowData: {}, // 当前行数据
      protectionMechanismForm: {
        interruptFeeIntervalTime: '', // 中断续费间隔时间
        suspensionCommissionIntervalTime: ''// 与推广者断开关系暂停分润间隔时间
      },
      dialogAdjustmentVidible: false,
      updateForm: {
        id: '',
        agentGrade: ''
      },
      option: {}
    };
  },
  mounted() {
    this.getTableList();
    this.getProtectionsInfo();
  },
  methods: {
    changeNumber(val) {
      this.searchForm.phoneNumber = val;
    },
    handleSearchFilter() {
      this.page.pageNum = 1;
      this.page.pageSize = 10;
      this.option = {
        spreadCode: this.searchForm.spreadCode, // 推广者ID
        agentGrade: this.searchForm.agentGrade, // 用户身份
        spreadType: this.searchForm.spreadType, // 账号类型
        phoneNumber: this.searchForm.phoneNumber// 手机号
      };
      this.getTableList();
    },
    pageCurriculumList(obj) {
      this.page.pageNum = obj.page;
      this.getTableList();
    },
    // 分页条数变化
    handleSizeChange(obj) {
      this.page.pageNum = 1;
      this.page.pageSize = obj.limit;
      this.getTableList();
    },
    // 获取列表
    getTableList() {
      this.listLoading = true;
      getSpreadersList({ ...this.option, pageNum: this.page.pageNum, pageSize: this.page.pageSize }).then(res => {
        this.listLoading = false;
        if (res.data === null || res.data === '' || res.data === 'undefind') {
          this.spreadersInfoList = [];
          this.page.total = 0;
        } else {
          this.spreadersInfoList = res.data.list;
          this.page.total = res.data.total;
        }
      }).catch(err => {
        // this.$message({ type: 'warning', message: '暂无数据' });
        this.listLoading = false;
        console.log(err);
      });
    },
    // 添加推广者
    handleaddSpreaders() {
      this.$refs['addAgentForm'].validate((valid) => {
        if (valid) {
          this.ajaxLoading = true;
          createSpreadersInfo(this.addAgentForm).then((res) => {
            this.ajaxLoading = false;
            this.$notify.success({ title: 'Success', message: '添加成功', showClose: false, duration: 2000 });
            this.getTableList();
            this.dialogAddVidible = false;
            this.$refs.addAgentForm.resetFields();
          }).catch(() => {
            this.ajaxLoading = false;
          });
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    // 关闭推广者弹框
    closePromoterDialog() {
      this.dialogAddVidible = false;
      this.$refs.addAgentForm.resetFields();
    },
    // 打开电话营销弹框
    openMarketingDialog(type, row) {
      this.currentRowData = row;
      if (type === 'market') {
        this.dialogMarketingVidible = true;
      } else {
        this.dialogAdjustmentVidible = true;
      }
    },
    // 转为推广者
    submitTelemarketing() {
      this.ajaxLoading = true;
      translationSpreaders(this.currentRowData.id).then((res) => {
        this.ajaxLoading = false;
        this.$notify.success({ title: 'Success', message: '修改成功', showClose: false, duration: 2000 });
        this.getTableList();
        this.dialogMarketingVidible = false;
      }).catch(() => {
        this.ajaxLoading = false;
      });
    },
    // 删除
    deletPromoterInfo(row) {
      this.$confirm(`是否确认删除该推广者，删除后，其下的推广者将与其解绑，学校类型的老师被删除后，按下个自然周的应用使用数据来判定，若符合，则依旧进入到待营销状态；`, '提示', { confirmButtonText: '确定', cancelButtonText: '取消', type: 'warning' }).then(() => {
        translationRemove(row.id).then((res) => {
          if (res.code === '0') {
            this.listLoading = true;
            this.$message({ type: 'success', message: '操作成功' });
            this.getTableList();
          }
        });
      }).catch(() => {});
    },
    // 设置推广者保护机制
    submitProtectionMechanism() {
      const pattern = new RegExp(/(^[1-9]\d*$)/);
      if (!pattern.test(this.protectionMechanismForm.interruptFeeIntervalTime) || !pattern.test(this.protectionMechanismForm.suspensionCommissionIntervalTime)) {
        this.$message.error('请输入数字');
        return;
      }
      this.ajaxLoading = true;
      saveProtectionsInfo(this.protectionMechanismForm).then((res) => {
        this.ajaxLoading = false;
        this.$notify.success({ title: 'Success', message: '添加成功', showClose: false, duration: 2000 });
        this.getTableList();
        this.dialogRulesVidible = false;
      }).catch((error) => {
        this.ajaxLoading = false;
        this.$notify.error({
          title: '错误信息',
          message: error.data.message,
          showClose: false,
          duration: 2000
        });
      });
    },
    // 查询推广者保护机制信息
    getProtectionsInfo() {
      getProtectionsInfo().then((res) => {
        this.protectionMechanismForm = res.data;
      }).catch(() => {});
    },
    // 关闭保护机制弹框
    closeProtectionDialog() {
      this.dialogRulesVidible = false;
      this.$refs.protectionMechanismForm.resetFields();
    },
    // 更新身份
    updateIdentity() {
      this.ajaxLoading = true;
      this.updateForm.id = this.currentRowData.id;
      changeIdentity(this.updateForm).then((res) => {
        this.ajaxLoading = false;
        this.$notify.success({ title: 'Success', message: '调整成功', showClose: false, duration: 2000 });
        this.getTableList();
        this.closeAgentFradeDialog();
      }).catch((error) => {
        this.ajaxLoading = false;
        this.$notify.error({ title: '错误信息', message: error.data.message, showClose: false, duration: 2000 });
      });
    },
    closeAgentFradeDialog() {
      this.dialogAdjustmentVidible = false;
      this.updateForm = {
        id: '',
        agentGrade: ''
      };
    },
    // 导出
    handleExportFilter() {
      var op = this.searchForm;
      window.location.href = exportSpreadersExcel(op) ? exportSpreadersExcel(op) : null;
    }
  }
};
</script>
<style lang="scss" scoped>
.table-box{
  padding: 0 30px;
}
.edit-form-input{
  width: 130px;
}
.editRules-form-input{
    width: 75%;
}
/deep/.el-dialog__body{
    padding: 10px 20px;
}
.content{
    line-height: 30px;
    font-size: 16px;
}
.right-box{
    position: relative;
    .downNum{
        position: absolute;
        right: 40px;
        top: -25px;
    }
}
</style>
